import baseStyles from "src/global.module.css";
import { Sheet } from "react-modal-sheet";
import { TbEdit } from "react-icons/tb";
import { MdDelete } from "react-icons/md";
import { FaXTwitter } from "react-icons/fa6";
import ModalSheetListItem from "src/components/elements/ModalSheetListItem/ModalSheetListItem";
import { useNavigate } from "react-router";
import ModalSheetListItemWithDialog from "src/components/elements/ModalSheetListItemWithDialog/ModalSheetListItemWithDialog";
import { useSetAtom } from "jotai";
import { toast } from "react-toastify";
import eventDelete from "src/utils/eventDelete";
import ErrorMessageToast from "src/components/ErrorMessageToast/ErrorMessageToast";
import getCurrentUserId from "src/utils/currentUserId";
import { deleteEventAtom } from "../../event.atom";

type EventCardMenuModalProps = {
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    event: {
        id: number;
        userId: number;
        title: string;
        place: string;
        name: string;
        eventType: string;
    };
};

const EventCardMenuModal: React.FC<EventCardMenuModalProps> = (props) => {
    const currentUserId = getCurrentUserId();
    const navigate = useNavigate();

    const setDeleteEvent = useSetAtom(deleteEventAtom);

    const isMyEvent = props.event.userId === currentUserId;

    const twitterShare = (
        title: string,
        place: string,
        postId: number,
        name: string,
    ) => {
        const shareUrl = `https://twitter.com/intent/tweet?text=『Street』で路上ライブの開催情報が共有されました！⭐️%0a%0aイベント情報：${title} %0a場所：${place}%0a%0a&hashtags=${name}%0a,路上ライブ%0a,Street%0a%0a↓ 開催地の位置情報など、詳しくはこちらを確認🎵%0ahttps://street-web.com/event/${postId}`;
        window.open(shareUrl, "_blank");
    };

    const handelEventDelete = async (eventId: number) => {
        try {
            await eventDelete(eventId, setDeleteEvent);
        } catch (error) {
            toast.error("削除に失敗しました");
        }
    };

    const navigateToEditEvent = () => {
        if (props.event.eventType === "street_event") {
            navigate(`/event/certified/edit/${props.event.id}`);
            return;
        }
        navigate(`/event/edit/${props.event.id}`);
    };

    const handelCloseModal = () => {
        props.setIsModalOpen(false);
    };

    return (
        <>
            <Sheet
                isOpen={props.isModalOpen}
                onClose={handelCloseModal}
                detent="content-height"
            >
                <Sheet.Container>
                    <Sheet.Content>
                        <Sheet.Scroller>
                            <div className={baseStyles.mb16} />
                            <ModalSheetListItem
                                text="SNSでシェア"
                                onClick={() => {
                                    twitterShare(
                                        props.event.title,
                                        props.event.place,
                                        props.event.id,
                                        props.event.name,
                                    );
                                }}
                                icon={<FaXTwitter size="3rem" />}
                                divider={isMyEvent}
                            />
                            {isMyEvent && (
                                <ModalSheetListItem
                                    text="イベントを編集・複製"
                                    onClick={navigateToEditEvent}
                                    icon={<TbEdit size="3rem" />}
                                    divider
                                />
                            )}
                            {isMyEvent && (
                                <ModalSheetListItemWithDialog
                                    text="イベントを削除"
                                    onClick={() => {
                                        handelEventDelete(props.event.id);
                                    }}
                                    icon={<MdDelete size="3rem" />}
                                    warning
                                    dialog={{
                                        title: "イベントを削除しますか？",
                                        content: "この操作は取り消せません。",
                                        onYes: {
                                            label: "削除する",
                                        },
                                    }}
                                />
                            )}
                        </Sheet.Scroller>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onTap={handelCloseModal} />
            </Sheet>
            <ErrorMessageToast />
        </>
    );
};

export default EventCardMenuModal;
